"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HTML = _ref => {
  let {
    html,
    id
  } = _ref;
  const ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    var _window$scriptLoaded;
    if (!html) return;
    const {
      current
    } = ref;
    if (current === null) return;
    const range = document.createRange();
    range.selectNodeContents(current);
    range.deleteContents();
    current.appendChild(range.createContextualFragment(html));
    const scriptLoaded = (_window$scriptLoaded = window.scriptLoaded) === null || _window$scriptLoaded === void 0 ? void 0 : _window$scriptLoaded[id];
    if (scriptLoaded) {
      window.location.reload();
    } else {
      setLoaded(id);
    }
    return () => {
      current.textContent = "";
    };
  }, [html, id]);
  const setLoaded = identifier => {
    window.scriptLoaded = window.scriptLoaded || {};
    window.scriptLoaded[identifier] = true;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  });
};
var _default = exports.default = HTML;